export const PRIORITY_VALUES = {
  REPORTING: 'reporting',
  AUTOMATION: 'automation',
  OVERSPEND: 'overspends',
  PERFORMANCE: 'performance',
}